/* START SOFTSKILLS USER COURSE */
export const GET_SOFTSKILLS_SURVEY = "GET_SOFTSKILLS_SURVEY"
export const GET_SOFTSKILLS_SURVEY_SUCCESS = "GET_SOFTSKILLS_SURVEY_SUCCESS"
export const GET_SOFTSKILLS_SURVEY_CLEAN = "GET_SOFTSKILLS_SURVEY_CLEAN"
export const GET_SOFTSKILLS_SURVEY_ERROR = "GET_SOFTSKILLS_SURVEY_ERROR"
